<template>
  <div id="centro-sub-tab">
    <v-layout align-center justify-center>
      <v-flex lg12>
        <template>
          <v-tabs v-model="active_tab">
            <v-tabs-slider :key="index" color="blue"></v-tabs-slider>
            <v-tab
              v-for="(tab, index) in tabs"
              :key="index"
              @click="selected(tab)"
              >{{ tab }}</v-tab
            >
            <v-tabs-items>
              <!-- TAB DE CUADRATURA CURSO -->
              <v-card
                :key="cardCurso"
                flat
                v-if="tabSelected == 'Cuadratura Curso'"
              >
                <curso
                  :show="true"
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></curso>
              </v-card>
              <!-- TAB DE CUADRATURA SERIE -->
              <v-card
                :key="cardSerie"
                flat
                v-if="tabSelected == 'Cuadratura Serie'"
              >
                <serie :tipeView="'modifica'" :contratoId="contratoId"></serie>
              </v-card>
              <!-- TAB DE REPORTES -->
              <v-card
                :key="cardReportes"
                flat
                v-if="tabSelected == 'Cuadratura Reportes'"
              >
                <reportes
                  :tipeView="'modifica'"
                  :contratoId="contratoId"
                ></reportes>
              </v-card>
            </v-tabs-items>
          </v-tabs>
        </template>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Curso from "@/modules/captura/views/cuadratura/CuadraturaCurso.vue";
import Serie from "@/modules/captura/views/cuadratura/CuadraturaSerie.vue";
import Reportes from "@/modules/captura/views/cuadratura/CuadraturaReportes.vue";

export default {
  name: "cuadratura-sub-tab",

  components: {
    Curso,
    Serie,
    Reportes,
  },
  props: {},
  data: () => ({
    proveedor: {},
    tabs: ["Cuadratura Curso", "Cuadratura Serie", "Cuadratura Reportes"],
    contratoId: "",
    tabSelected: "",
    activeTab: "",
    index: "",
    active_tab: "",
    cardCurso: 0,
    cardSerie: 10,
    cardReportes: 20,
  }),
  mounted() {},
  created() {
    if (this.$store.getters.subTabSelectedStored < 0) {
      this.$store.getters.subTabSelectedStored = 0;
    }
    this.subPro = this.$store.getters.subProTabSelectedStored;
    this.tab = this.$store.getters.subTabSelectedStored;
    this.proceso = this.$store.getters.proSelectedStored;

    if (
      !this.$route.params.contratoId ||
      this.$route.params.contratoId == null ||
      this.$route.params.contratoId == ""
    ) {
      this.contratoId = this.$store.getters.contratoStored;
    } else {
      this.contratoId = this.$route.params.contratoId;
    }
    this.tabSelected = this.$store.getters.subTabSelectedStored;
    this.active_tab = this.tabs.indexOf(
      this.$store.getters.subTabSelectedStored
    );
  },
  methods: {
    selected(tab) {
      this.tabSelected = tab;
      this.$store.commit("sub_tab_state", tab);

      if (this.tabSelected == "Cuadratura Curso") {
        this.reloadCurso();
      }
      if (this.tabSelected == "Cuadratura Serie") {
        this.reloadSerie();
      }
      if (this.tabSelected == "Cuadratura Reportes") {
        this.reloadReportes();
      }
    },
    reloadCurso() {
      this.cardCurso += 1;
    },
    reloadSerie() {
      this.cardSerie += 11;
    },
    reloadReportes() {
      this.cardReportes += 21;
    },
  },
};
</script>
